// Logo gold palette (#C7B45E). Literal hex on purpose — used directly on
// borders/text/buttons instead of Chakra theme tokens (brand.500 etc.) so
// these colors render correctly even if the theme file's HMR/cache lags.
// Keep in sync with the `brand` scale in src/theme/styles.js.
export const GOLD_BORDER = '#C7B45E'; // logo gold — borders, focus rings, solid fills
export const GOLD_TEXT = '#8F7A2E';   // darker gold — readable text on white, hover fill
export const GOLD_LIGHT = '#F3EDD6';  // light gold tint — hover backgrounds on outline buttons
